












import { defineComponent, reactive, watch } from '@vue/composition-api';

interface FilterState {
	keys: string[];
	activeFilters: string[][];
}

export default defineComponent({
	props: {
		id: {
			type: String,
			required: true,
		},
		itemkey: {
			type: String,
			required: true,
		},
		resultsfilterid: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		filters: {
			type: Object as () => FilterState,
		},
		singleselect: {
			type: Boolean,
			default: false,
		},
		groupname: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const state = reactive<{ active: boolean }>({
			active: false,
		});

		if (!props.filters?.keys.includes(props.groupname)) {
			props.filters?.keys.push(props.groupname);
			props.filters?.activeFilters.push([]);
		}
		watch(state, () => {
			if (!props.filters) {
				return;
			}
			const index = props.filters.keys.indexOf(props.groupname);
			if (!state.active) {
				if (props.filters.activeFilters[index] && props.filters.activeFilters[index].includes(props.itemkey)) {
					props.filters.activeFilters[index].splice(
						props.filters.activeFilters[index].indexOf(props.itemkey),
						1,
					);
				}
				return;
			}
			props.filters.activeFilters[index].push(props.itemkey);
		});
		return { state };
	},
});
